import { ChartFrame } from 'components/ChartFrame'
import Resultbar from 'components/Resultbar'
import { TextBuilder } from 'components/TextBuilder/TextBuilder'
import { formatNumber } from 'components/Utils/formatNumber'
import styled from 'styled-components'

const locales = {
  de: {
    title: 'So schneiden Sie im Vergleich mit den anderen Teilnehmenden ab',
  },
}

const RightOrWrong = ({
  userCorrect,
  userTotal,
  participantsCorrect,
  participantsCount,
}: {
  userCorrect: number
  userTotal: number
  participantsCorrect: number
  participantsCount: number
}) => {
  const text_1 = new TextBuilder()
    .decide_by_range(userCorrect, [
      [[0, 0], 'Sie haben alle Produkte falsch entsorgt.'],
      [
        [0.1, 99],
        <>
          Sie haben{' '}
          <b>{formatNumber(userCorrect)} Prozent der Produkte richtig</b> und{' '}
          <b>{formatNumber(100 - userCorrect)} Prozent falsch</b> entsorgt.
        </>,
      ],
      [[100, 101], 'Sie haben alle Produkte richtig entsorgt.'],
    ])
    .add(' Damit kennen Sie sich ')
    .compare(userCorrect, participantsCorrect, [
      'schlechter ',
      'genau so gut ',
      'besser ',
    ])
    .add(
      'mit Recycling aus als der Durchschnitt der anderen Teilnehmenden.'
    )

  return (
    <RightOrWrongContainer>
      <ChartFrame
        lang='de'
        title={locales.de.title}
        lead={text_1.get()}
        colorKeyEntries={[
          { color: 'var(--correct-color)', label: 'richtig' },
          { color: 'var(--wrong-color)', label: 'falsch' },
        ]}
      >
        <Resultbar
          correct={userCorrect}
          secondary
          label={
            <>
              <b>Ihr Ergebnis: </b>{' '}<br/>
              <div className='small'>
                Sie haben bisher {userTotal} von 30 Produkten zugeordnet.
              </div>
            </>
          }
          hideValueLabels
        />
        <Spacer />
        <Resultbar
          correct={participantsCorrect}
          label={
            <>
              <>
                <span>
                  Durchschnitt aller anderen{' '}
                  <b>{participantsCount} Teilnehmerinnen und Teilnehmer:</b>
                </span>
              </>
            </>
          }
          hideValueLabels
          secondary
        />
      </ChartFrame>
    </RightOrWrongContainer>
  )
}
const Spacer = styled.div`
  width: 100%;
  display: inline-block;
  height: 10px;
`
const EvaluationText = styled.div`
  font-size: 18px;
  line-height: 27px;
  margin-top: 30px;
  margin-bottom: 30px;
  font-family: var(--font-serif);
`
const RightOrWrongContainer = styled.div`
  @media screen and (max-width: 711px) {
    font-size: 17px;
    line-height: 28px;
  }
`

export default RightOrWrong
